import React from "react";
import style from "./Footer.module.css";

export const Footer = () => {
  return (
    <div className={style.footer}>
      <span>Created by Aldrek</span>
    </div>
  );
};
